export default __webpack_public_path__ + "media/images/admin/default-202d598f5a55f7e65e4420ce5c576cae.png";